/**
 * Link-liveness verdict vocabulary (PIP-163), shared by every consumer of
 * `Event.linkStatus` so they cannot drift apart (COR-115).
 *
 * The column is a free `String?` in the Prisma schema; these are the only
 * values the writers emit (PIP-163's sweeper, PIP-255's Eventbrite dead-listing
 * path and the detail backfill). `NULL` means never checked.
 *
 * Three readers must agree on what "dead" means, and import it from here:
 *   - backend-api `resolveCtaHref` suppresses the ticket CTA,
 *   - `@loci/validation` `scoreEventForPlacement` emits `SOURCE_LINK_DEAD`,
 *   - data-pipeline's link writers record it.
 */

/** Recorded on `Event.linkStatus`. `suspect` = the check proved nothing. */
export type LinkStatus = 'ok' | 'dead' | 'suspect';

/** The page the CTA would open is gone (404/410, or a provider "unavailable" page). */
export const DEAD_LINK_STATUS = 'dead' satisfies LinkStatus;

/** The page answered and proved the listing live. */
export const LIVE_LINK_STATUS = 'ok' satisfies LinkStatus;
